/* eslint-disable no-lonely-if */

const methods = {
    fetchData() {
        this.getComments();
        this.getFiles();
        this.getMe();
    },

    async getComments() {
        this.loadingComments = true;
        this.timeline = [];
        try {
            const resComments = await this.$issuesService.getComments(this.uuidIssue);
            const { comments } = resComments.data;
            this.timeline = comments;
            this.loadingComments = false;
        } catch (error) {
            this.$toast.error('Error', error);
            this.loadingComments = false;
        }
    },

    async getFiles() {
        this.loadingFiles = true;
        this.files = [];
        try {
            const resFiles = await this.$issuesService.files(this.uuidIssue);
            const { documents } = resFiles.data;
            this.files = documents;
            this.loadingFiles = false;
        } catch (error) {
            this.loadingFiles = false;
            this.$toast.error('Error', error);
        }
    },

    getMe() {
        this.$usersService
        .getMe()
        .then(res => {
            this.$store.dispatch('meStore/setIssues', res.data.issues);
        });
    },

    /**
     * Enviamos un comentario a una incidencia
     */
    sendComment() {
        this.uploading = true;
        if (this.comment.length > 10) {
            Promise.all([
                this.$issuesService.comment(this.issue, { comment: this.comment }),
                this.$issuesService.updateValue(this.issue, {
                    status: this.resolved ? 'RESOLVED' : this.issue.status,
                    resolved_on: this.resolved ? new Date() : null
                })
            ])
                .then(res => {
                    this.resetActions();
                    this.issue = res[1].data.issue;
                    this.$emit('issueHasChanges', res[1].data.issue);
                    if (res[0].result && res[0].result.http_code !== 201) {
                        this.$toast.error(`Error ${res[0].result.http_code}`, `${res[0].result.info}`);
                    } else {
                        this.fetchData();
                        this.$toast.success(`${res[0].result.http_code}`, `${res[0].result.info}`);
                    }
                })
                .catch(err => {
                    this.resetActions();
                    this.$toast.error(`Error ${err.name}`, `${err.message}`);
                });
        }
    },

    /**
     * Vuelve al estado original todas las variables
     */
    resetActions() {
        this.uploading = false;
        this.$bvModal.hide('modalChangeStatus');
        this.$bvModal.hide('modalChangeResponsable');
        this.activeSectionFooter = null;
        this.comment = null;
        this.filesArray = [];
        this.filenamesArray = [];
        this.resolved = false;
    },

    /**
     * Muestra una sección (comentar/asignar/upload)
     * @param {String} section Nombre de la sección
     */
    viewSection(section) {
        if (this.activeSectionFooter === section) {
            this.resetActions();
        } else if (section === 'comment') {
            // Comprobamos el estado de la tarea.
            // Si está OPEN -> abrimos modal
            if (this.issue.status === 'OPEN') {
                this.$bvModal.show('modalChangeStatus');
            } else {
                // Comprobamos a quién está asignada.
                // Si está asignada a un grupo -> abrimos modal
                if (!this.issue.user_assigned && !this.modalResponsableShowed) {
                    this.$bvModal.show('modalChangeResponsable');
                } else {
                    this.activeSectionFooter = section;
                    setTimeout(() => {
                        this.$refs.commentRef.focus();
                    }, 100);
                }
            }
        } else {
            this.activeSectionFooter = section;
        }
    },

    /**
     * Re-abrimos una incidencia y la ponemos en estado OPEN
     * @param {String} newStatus Nuevo estado al que cambiar la issue
     */
    changeStatusTo(newStatus) {
        this.$issuesService
            .updateValue(this.issue, { status: newStatus })
            .then(res => {
                this.fetchData();
                if (res.result && res.result.http_code !== 200) {
                    this.$toast.error(`Error ${res.result.http_code}`, `${res.result.info}`);
                } else {
                    this.issue = res.data.issue;
                    this.$emit('issueHasChanges', res.data.issue);
                    this.$bvModal.hide('modalChangeStatus');
                    this.$toast.success(`${res.result.http_code}`, `${res.result.info}`);
                }
            })
            .catch(err => {
                this.$toast.error(`Error ${err.name}`, `${err.message}`);
            });
    },
    /**
     * @override
     */
    onSearchChange(query) {
        const cfg = {
            params: {
                // '$expand': 'group,permission_set'
            }
        };
        const q = query.split(' ');
        Promise.all([
            this.$usersService.getSearch(JSON.stringify(q), cfg),
            this.$groupsService.getSearch(JSON.stringify(q), cfg)
        ]).then(res => {
            const users = res[0].data.users.map(x => {
                return {
                    uuid: x.uuid,
                    name: `${x.given_name} ${x.family_name_1} ${x.family_name_2 ? x.family_name_2 : ''}`,
                    link: x._links._self.href,
                    type: 'user'
                };
            });
            const groups = res[1].data.groups.map(x => {
                return {
                    uuid: x.uuid,
                    name: `${x.key_name}`,
                    link: x._links._self.href,
                    type: 'group'
                };
            });
            this.asigneeType = [
                {
                    language: 'Users',
                    libs: users
                },
                {
                    language: 'Groups',
                    libs: groups
                }
            ];
        });
    },
    /**
     * @override
     */
    changeReponsable(e) {
        let payload;

        if (e.type === 'group') {
            payload = {
                uuid: this.issue.uuid,
                data: {
                    _links: {
                        group_assigned: e.link,
                        user_assigned: null
                    }
                }
            };
        } else {
            payload = {
                uuid: this.issue.uuid,
                data: {
                    _links: {
                        user_assigned: e.link,
                        group_assigned: null
                    }
                }
            };
        }

        this.$issuesService
            .changeUserResponsable(payload)
            .then(response => {
                this.resetActions();
                this.issue = response.data.issue;
                this.$emit('issueHasChanges', response.data.issue);
                this.fetchData();
                this.$toast.success(`${response.result.http_code}`, `${response.result.info}`);
            })
            .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
    },

    /**
     * @override
     */
    assignToMe() {
        const USERS_API_HOST = process.env.VUE_APP_USERS_API_HOST || process.env.VUE_APP_API_HOST;
        const USERS_API_CONTEXT = process.env.VUE_APP_USERS_API_CONTEXT || 'users-api';

        const { user } = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
        const payload = {
            uuid: this.issue.uuid,
            data: {
                _links: {
                    user_assigned: `${USERS_API_HOST}/${USERS_API_CONTEXT}/${user.uuid}`,
                    group_assigned: null
                }
            }
        };
        this.$issuesService
            .changeUserResponsable(payload)
            .then(response => {
                this.resetActions();
                this.issue = response.data.issue;
                this.$emit('issueHasChanges', response.data.issue);
                this.fetchData();
                this.$toast.success(`${response.result.http_code}`, `${response.result.info}`);
            })
            .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
    },

    /**
     * @override
     */
    onlyComment(modal) {
        this.$bvModal.hide('modalChangeStatus');
        this.$bvModal.hide('modalChangeResponsable');
        this.activeSectionFooter = 'comment';
        setTimeout(() => {
            this.$refs.commentRef.focus();
        }, 100);
        if (modal === 'modalChangeResponsable') {
            this.modalResponsableShowed = true;
        }
    },

    /**
     * @override
     */
    onFileChange(e) {
        const maxSize = 300 * 1024 * 1024; // 300MB
        const selectedFiles = e.target.files;

        for (let i = 0; i < selectedFiles.length; i++) {
            if (
                selectedFiles[i].size < maxSize &&
                (selectedFiles[i].type === 'application/pdf' ||
                    selectedFiles[i].type === 'image/jpeg' ||
                    selectedFiles[i].type === 'image/jpg' ||
                    selectedFiles[i].type === 'image/png')
            ) {
                this.filesArray.push(selectedFiles[i]);
                this.filenamesArray.push(selectedFiles[i].name);
            } else if (selectedFiles[i].size > maxSize) {
                this.$toast.error(
                    'Tamaño incorrecto',
                    `No se permite archivos más grandes de 300MB. El archivo ${
                        selectedFiles[i].name
                    } no se puede añadir a la cola de uploads.`
                );
            } else {
                this.$toast.error(
                    'Formato incorrecto',
                    `Sólo se pueden subir documentos en formato PDF e imágenes (jpg, png).`
                );
            }
        }

        for (let i = 0; i < this.filesArray.length; i++) {
            const reader = new FileReader();
            reader.onload = () => {
                if (
                    this.filesArray[i].type === 'image/png' ||
                    this.filesArray[i].type === 'image/jpg' ||
                    this.filesArray[i].type === 'image/jpeg'
                ) {
                    this.$refs.image[i].src = reader.result;
                }
            };
            reader.readAsDataURL(this.filesArray[i]);
        }
    },

    /**
     * @override
     */
    removeFile(index) {
        this.filesArray.splice(index, 1);
        this.filenamesArray.splice(index, 1);
        this.$refs.filesRef.value = '';
    },

    /**
     * @override
     */
    doUpload() {
        this.uploading = true;
        this.$issuesService
            .upload(this.issue, this.filesArray, this.filenamesArray)
            .then(response => {
                this.uploading = false;
                this.getComments();
                this.getFiles();
                this.resetActions();
                this.$toast.success(`${response.result.http_code}`, `Archivos añadidos a la incidencia con éxito.`);
            })
            .catch(err => {
                this.$toast.error(`Error ${err.name}`, `${err.message}`);
                this.uploading = false;
            });
    },
    prepareFetchData() {
        this.uuidIssue = this.$route.query.id ? this.$route.query.id : this.uuid;
        this.$issuesService.getIssuesByUUIId(this.uuidIssue).then(res => {
            this.issue = res.data.issue;
            this.fetchData();
        });
    }
};

export default methods;
